import SettingsList from './SettingsList';
import SettingsCreate from './SettingsCreate';
import SettingsEdit from './SettingsEdit';

export const settings = {
  list: SettingsList,
  create: SettingsCreate,
  edit: SettingsEdit,
};
